import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { closestCenter, defaultDropAnimationSideEffects, DndContext, DragOverlay, KeyboardSensor, MeasuringStrategy, MouseSensor, TouchSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy, } from '@dnd-kit/sortable';
import { cloneDeep } from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Box } from "../../../../box/src";
import { Container } from './Container';
import { DraggableContainer } from './DraggableContainer';
import { DraggableList } from '../DraggableList';
const dropAnimation = {
    sideEffects: defaultDropAnimationSideEffects({
        styles: {
            active: {
                opacity: '0.5',
            },
        },
    }),
};
const ContainerDragOverlay = ({ MultipleRowComponent, MultipleTitleComponent, containerId, dataSource, }) => {
    const selectedContainer = useMemo(() => dataSource.find(({ id }) => id === containerId), [dataSource, containerId]);
    if (!selectedContainer)
        return null;
    const { isOpen, items, label } = selectedContainer;
    return (_jsx(Container, { id: containerId, isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : true, label: label, TitleComponent: MultipleTitleComponent, children: _jsx(DraggableList, { dataSource: items, onDataChange: () => { }, RowComponent: MultipleRowComponent }) }));
};
export const DragAndDropContainer = ({ MultipleDragOverlayComponent, MultipleRowComponent, MultipleTitleComponent, dataSource, onDataChange, }) => {
    const [activeId, setActiveId] = useState(null);
    const recentlyMovedToNewContainer = useRef(false);
    useEffect(() => {
        requestAnimationFrame(() => {
            recentlyMovedToNewContainer.current = false;
        });
    }, [dataSource]);
    const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor), useSensor(KeyboardSensor));
    const onItemChange = (containerIndex, sortedDataSource) => {
        const clonedDataSource = cloneDeep(dataSource);
        clonedDataSource[containerIndex].items = sortedDataSource;
        onDataChange(clonedDataSource);
    };
    const onContainerOrderChange = (activeId, overId) => {
        const activeIndex = dataSource.findIndex(({ id }) => id === activeId);
        const overIndex = dataSource.findIndex(({ id }) => id === overId);
        onDataChange(arrayMove(dataSource, activeIndex, overIndex));
    };
    const onDragStart = ({ active }) => {
        setActiveId(active.id);
    };
    const onDragEnd = ({ active, over }) => {
        if (over === null)
            return;
        onContainerOrderChange(active.id, over.id);
        setActiveId(null);
    };
    return (_jsxs(DndContext, { collisionDetection: closestCenter, measuring: {
            droppable: {
                strategy: MeasuringStrategy.Always,
            },
        }, onDragEnd: onDragEnd, onDragStart: onDragStart, sensors: sensors, children: [_jsx(Box, { flexDirection: "column", p: 4, width: "100%", children: _jsx(SortableContext, { items: dataSource, strategy: verticalListSortingStrategy, children: dataSource.map((container, containerIndex) => (_jsx(DraggableContainer, { container: container, TitleComponent: MultipleTitleComponent, children: _jsx(DraggableList, { dataSource: container.items, DragOverlayComponent: MultipleDragOverlayComponent, onDataChange: (sortedDataSource) => {
                                onItemChange(containerIndex, sortedDataSource);
                            }, RowComponent: MultipleRowComponent }) }, container.id))) }) }), createPortal(_jsx(DragOverlay, { dropAnimation: dropAnimation, children: activeId && (_jsx(ContainerDragOverlay, { containerId: activeId, dataSource: dataSource, MultipleRowComponent: MultipleRowComponent, MultipleTitleComponent: MultipleTitleComponent })) }), document.body)] }));
};
//# sourceMappingURL=DragAndDropContainer.js.map